import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

export default function SuccessView() {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="glass-panel p-10 rounded-3xl max-w-lg w-full text-center border-emerald-500/30"
      >
        <motion.div 
          initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: 'spring', delay: 0.2 }}
          className="w-24 h-24 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <SafeIcon icon="Check" className="w-12 h-12 text-emerald-400" />
        </motion.div>
        
        <h1 className="text-3xl font-bold text-white mb-4">Thank you!</h1>
        <p className="text-slate-300 text-lg mb-8">
          We have received your details. We will match you with a trusted installer in your area shortly.
        </p>

        <button 
          onClick={() => window.location.reload()}
          className="px-8 py-3 bg-slate-800 hover:bg-slate-700 text-white rounded-full font-medium transition-colors border border-slate-700"
        >
          Start New Assessment
        </button>
      </motion.div>
    </div>
  );
}